var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"share",on:{"click":_vm.clickShare}},[_c('img',{staticClass:"share-icon",attrs:{"alt":"","src":require("./assets/share-icon.png")}}),_c('span',{staticClass:"share-tip",attrs:{"role":"button"}},[_vm._v(_vm._s(_vm.i18n('嗌好友一齊免費拎券')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }